import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef
} from "react";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

import OverLoading from "../global/OverLoading";
import { updateCategory, getCategory } from "../../actions/admin/category";
import { toggleModal } from "../../actions/modal";

const FormEdit = forwardRef(
  ({ updateCategory, getCategory, toggleModal, id }, ref) => {
    const submitButtonRef = useRef();

    useImperativeHandle(ref, () => ({
      submitForm() {
        submitButtonRef.current.click();
      }
    }));

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
      name: "",
      group: ""
    });

    const { name, group } = formData;

    useEffect(() => {
      const fetchCategoryData = async () => {
        const selectedCategory = await getCategory(id);
        console.log("SelectedCategory=");
        console.log(selectedCategory)
        setFormData({
          name: selectedCategory.name,
          group: selectedCategory.group
        });
      };

      fetchCategoryData();
    }, [getCategory, id]);

    const onChange = e =>
      setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
      e.preventDefault();
      setLoading(true);

      try {
        await updateCategory(formData, id).then((response) => {
          if( response.status === 200 ){
            setLoading(false);
            toast.success("Category Updated.");
          }else{
            toast.error("An unexpected error has occurred");
          } 
        });
      } catch (err) {
        toast.error(err)
      }

      toggleModal();
    };

    return (
      <form
        className="form position-relative"
        onSubmit={e => onSubmit(e)}
        autoComplete="off"
      >
        {loading && <OverLoading />}
        <div className="form-group">
          <label className="col-form-label">Name</label>
          <TextField name="name" className="form-control" value={name} multiline={true} onChange={e => onChange(e)} />
        </div>
        <div className="form-group">
          <label className="col-form-label">Group</label>
          <input
            type="text"
            className="form-control"
            name="group"
            value={group}
            onChange={e => onChange(e)}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="submit"
            className="btn btn-primary mr-1 d-none"
            value="Save"
            ref={submitButtonRef}
          />
        </div>
      </form>
    );
  }
);

FormEdit.propTypes = {
  getCategory: PropTypes.func.isRequired,
  updateCategory: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired
};

export default connect(
  null,
  { updateCategory, getCategory, toggleModal },
  null,
  {
    forwardRef: true
  }
)(FormEdit);
